import { ContactType } from '../../../../common/enums/ContactType';

export const getProfileIcon = (role: ContactType) => {
  switch (role) {
    case ContactType.Candidate:
      return 'user';
    case ContactType.Reference:
      return 'inactiveStar';
    case ContactType.Prospect:
      return 'prospects';
    default:
      return 'user';
  }
};
